import { CSOperatingSystem } from '@websrc/Typings/ContentStack'

type OperatingSystem = CSOperatingSystem['select']

interface Platforms {
  [platform: string]: { userAgents: string[]; devices: OperatingSystem[] }
}

const platforms: Platforms = {
  mac: { userAgents: ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'], devices: ['Mac OS'] },
  windows: {
    userAgents: ['Win32', 'Win64', 'Windows', 'WinCE'],
    devices: [
      'Windows 10',
      'Windows (7, 8.1, 10)',
      'Windows 10 (touch devices)',
      'Windows 7',
      'Windows 8.1',
    ],
  },
  ios: { userAgents: ['iPhone', 'iPad', 'iPod'], devices: ['iPad'] },
  chrome: { userAgents: ['CrOS'], devices: ['Chromebook'] },
  android: { userAgents: ['Android'], devices: ['Android'] },
}

export const getDevices = () => {
  let devices: OperatingSystem[] = ['Mac OS']

  if (typeof window !== 'undefined') {
    const { userAgent } = window.navigator

    const detectedPlatform = Object.values(platforms).find((p) =>
      p.userAgents.some((ua) => userAgent.includes(ua))
    )

    if (detectedPlatform) {
      if (
        // On newer iPads using Safari, the useragent is the same as on a Mac
        // To tell them apart we check the "standalone" property which only exists in iOS Safari
        detectedPlatform.devices.includes('Mac OS') &&
        typeof (navigator as any).standalone !== 'undefined'
      ) {
        devices = platforms.ios.devices
      } else {
        devices = detectedPlatform.devices
      }
    }
  }

  return devices
}
